enum BillingTypes {
  Campaigns = 'campaignBillingHistory',
  ContentLibrary = 'contentLibraryPurchases',
}

export { BillingTypes }
